import { Reducer, AnyAction } from 'redux'

import { LiveChatSnippet } from 'apps/chat/constants/LiveChatInterfaces'

import { default as basicSettingsReducer } from './reducers/settings'
import { reducer as snippetsReducer } from './redux/snippetsSlice'

type BasicSettingsState = ReturnType<typeof basicSettingsReducer>
type SettingsState = Omit<BasicSettingsState, 'liveChatSnippets'> & {
  liveChatSnippets: LiveChatSnippet[]
}

const combinedSettingsReducer: Reducer<SettingsState, AnyAction> = (state, action) => {
  const intermediateState = basicSettingsReducer(state as BasicSettingsState, action)
  const liveChatSnippets = snippetsReducer(state?.liveChatSnippets ?? [], action)

  return {
    ...intermediateState,
    liveChatSnippets,
  }
}

export { initialState as settingsInitialState } from './reducers/settings'
export { ordersReducer } from './reducers/paymentOrders'
export { default as botSettingsReducer } from './reducers/botSettings'
export { default as devLogsReducer } from './reducers/devLogs'
export { default as eventsReducer } from './reducers/events'
export { settingsAutoAssignmentReducer } from './reducers/autoAssignment'
export { combinedSettingsReducer as settingsReducer }
